import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4 py-16" data-testid="payment-cancel-page">
      <div className="w-full max-w-md rounded-3xl border border-white/10 bg-[#141419] p-10 text-center">
        <XCircle className="mx-auto text-zinc-500" size={40} />
        <h1 className="font-heading mt-6 text-2xl font-bold text-white">Checkout cancelled</h1>
        <p className="mt-2 text-sm text-zinc-500">No charge was made. Your beat is still in the store whenever you're ready.</p>
        <Link to="/beats" data-testid="payment-cancel-back-link"
          className="mt-6 inline-block rounded-full bg-emerald-300 px-8 py-3 text-sm font-bold uppercase tracking-wider text-black hover:bg-emerald-200">
          Back to Beats
        </Link>
      </div>
    </div>
  );
}
